module.exports = __webpack_public_path__ + "img/kpi.7a82ffd0.png";